import jQuery from 'jquery';
let $ = jQuery;
import A11Y from 'HSNDIR/AccessibilityUtility.js';
import Events from "HSNDIR/Events.js";

/**
    * class HSN.Widget.Tabs
    *
    * Encapsulates the common functionality of the Tabs Widget.
    * Accessible tabs that offer keyboard navigation with manual activation with spacebar and/or enter keys
    * follows aria practices for accessibility from https://www.w3.org/TR/wai-aria-practices/#tabpanel
**/

HSN.Widget.Tabs = function() {
    let application;
    let container;
    let tabList;
    let tabs;
    let panels;
    let keys;
    let arrowKeyDirections;
    let focusTimeout;

    /**
        * new HSN.Widget.Tabs.init(config)
        * - config (Object): A configuration object for the [[HSN.Widget.Tabs]]
        *   consisting of the following keys:
        *   - application (HSN.Application): An instance of the [[HSN.Application]] that the widget should interact with.
        *   - container (HTMLElement | jQuery | String): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element will act as the root container for the widget.
    **/
    function init(config) {
        application = config.application;
        container = $(config.container);

        //select tab elements based off of role schematics
        tabList = container.find('[role="tablist"]');
        tabs = container.find('[role="tab"]');
        panels = container.find('[role="tabpanel"]');

        //use a11y helper to get keyboard keys and directions to use in events
        keys = A11Y.GetKeys();                   
        bindEvents();

    }

    function bindEvents() {
        
        tabs.on('click', (event) => {
            var tab = $(event.target);
            activateTab(tab, false)
        });
        
        tabs.on('keydown', () => keydownEventListener(event));
        tabs.on('keyup', () => keyupEventListener(event));
        tabList.on('keydown', () => tabListEventListener(event));
    }

    function tabListEventListener(event) {
        var key = event.keyCode;
        if (key === keys.spacebar || key === keys.enter) {
            event.preventDefault();
            $(tabs[0]).focus();
        }
        else if (key !== keys.tab) {
            event.preventDefault();
        }
    }

    function keydownEventListener (event) {
        var key = event.keyCode;
        event.preventDefault();
        switch (key) {
            case keys.end:
                // Activate last tab
                $(tabs[tabs.length - 1]).focus();
                break;
            case keys.home:
                // Activate first tab
                $(tabs[0]).focus();
                break;
            case keys.up:
            case keys.down:
                switchTabOnArrowPress(event);
                break;
        }

        return false;
    }

    function keyupEventListener (event) {
        var key = event.keyCode;

        switch (key) {
            case keys.left:
            case keys.right:
                switchTabOnArrowPress(event);
                break;
            case keys.tab:
                unfocusActiveTab(event);
                break;
            case keys.spacebar:
            case keys.enter:
                focusActiveTab(event);
        };

        return false;
    }

    function activateTab (tab, setFocus) {
        setFocus = setFocus || true;
        deactivateTabs();
        tab.removeAttr('tabindex');
        tab.attr('aria-selected', true);

        var controlElementId = '#' + tab.attr('aria-controls');
        $(controlElementId).removeAttr('hidden');
       
        if (setFocus) {
            tab.focus();
        }

        application.Events.Trigger(Events.Widget.Tabs.SHOW, tab);
    }

    function deactivateTabs () {
        tabs.each(function(index) {
            A11Y.SetTabIndexProgrammatic($(this));

            $(this).attr('aria-selected', false);
            $(this).blur();

        });

        panels.each(function(index) {
            $(this).attr('hidden', 'hidden');
        });
    }

    function switchTabOnArrowPress (event) {
        var key = event.keyCode;
        var target = $(event.target);
        
        if(key === keys.left || key === keys.up) {
            target.prev().focus();
        }
        
        if(key === keys.right || key === keys.down) {
            target.next().focus();
        }
    }

    function focusActiveTab(event) {
        var target = $(event.currentTarget);
        focusTimeout = setTimeout(checkTabFocus, 1, target);
    }

    function unfocusActiveTab(event) {
        var target = $(event.target);
        target.blur();
    }

    function checkTabFocus (target) {
        var focused = $(document.activeElement);
        
        if (target.is(focused)) {
            activateTab(target, false);
            clearTimeout(focusTimeout);
            focusTimeout = null;
        };
    }

    function destroy() {
        tabs.off('click', (event) => {});
        tabs.off('keydown', () => keydownEventListener(event));
        tabs.off('keyup', () => keyupEventListener(event));   

        application = container = tabs = focusTimeout = null;
    }

    return {
        init : init,
        destroy: destroy
    };
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Widget/Tabs.js